// Mapbox configuration
export const MAPBOX_ACCESS_TOKEN = 'pk.eyJ1IjoiaGVybWFuNjl4eCIsImEiOiJjbWhudmJ5ZXAwNXM0MmtxdnNnd2V1M3pyIn0.Uam63DQ2RJF1ZPY0XcpnGg';
export const MAPBOX_STYLE = 'navigation-night-v1';

